(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class ImageCarousel {
      constructor(container) {
        this.container = container;
        this.slider = container.querySelector('[data-image-slider]');
        this.slides = container.querySelectorAll('.image-carousel-slide');
        this.prevBtn = container.querySelector('.image-carousel-prev');
        this.nextBtn = container.querySelector('.image-carousel-next');
        this.init();
      }
      init() {
        if (!this.slider || this.slides.length <= 1) return;
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());
        this.slider.addEventListener('scroll', () => this.updateButtonStates());
        this.updateButtonStates();
      }
      getScrollAmount() {
        var slide = this.slides[0];
        if (!slide) return 0;
        var gap = parseInt(window.getComputedStyle(this.slider).gap) || 16;
        return slide.offsetWidth + gap;
      }
      next() { this.slider.scrollBy({ left: this.getScrollAmount(), behavior: 'smooth' }); }
      prev() { this.slider.scrollBy({ left: -this.getScrollAmount(), behavior: 'smooth' }); }
      updateButtonStates() {
        if (!this.prevBtn || !this.nextBtn) return;
        var maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        var atStart = this.slider.scrollLeft <= 0;
        var atEnd = this.slider.scrollLeft >= maxScroll - 1;
        this.prevBtn.disabled = atStart;
        this.prevBtn.style.opacity = atStart ? '0.3' : '1';
        this.nextBtn.disabled = atEnd;
        this.nextBtn.style.opacity = atEnd ? '0.3' : '1';
      }
    }
    function initCarousels() {
      document.querySelectorAll('.image-carousel-section').forEach(function (s) { new ImageCarousel(s); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCarousels);
    } else {
      initCarousels();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["key-ingredients-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initKeyIngredients() {
      document.querySelectorAll('.ki').forEach(function (section) {
        /* tap a card (mobile) to flip between name and description */
        section.querySelectorAll('.ki__card').forEach(function (card) {
          card.addEventListener('click', function () {
            var open = card.classList.toggle('is-open');
            var btn = card.querySelector('.ki__toggle');
            if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          });
        });

        /* carousel nav */
        var track = section.querySelector('[data-ki-track]');
        var prev = section.querySelector('[data-ki-prev]');
        var next = section.querySelector('[data-ki-next]');
        if (!track || !prev || !next) return;

        function step() {
          var card = track.querySelector('.ki__card');
          if (!card) return 0;
          var gap = parseInt(window.getComputedStyle(track).gap) || 16;
          return card.offsetWidth + gap;
        }
        function sync() {
          var max = track.scrollWidth - track.clientWidth;
          prev.disabled = track.scrollLeft <= 0;
          next.disabled = track.scrollLeft >= max - 1;
        }
        prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
        track.addEventListener('scroll', sync);
        window.addEventListener('resize', sync);
        sync();
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initKeyIngredients);
    } else {
      initKeyIngredients();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
